/**
 * English dictionary word lookup for game validation.
 * Uses the free Dictionary API (dictionaryapi.dev) — there is no public Google Dictionary API.
 */
const DICTIONARY_API_BASE = 'https://api.dictionaryapi.dev/api/v2/entries/en';
const wordCache = new Map();

export async function validateDictionaryWord(word) {
  const normalized = String(word ?? '')
    .trim()
    .toLowerCase()
    .replace(/[^a-z]/g, '');

  if (!normalized) {
    return { valid: false, message: 'Enter a valid word' };
  }

  if (wordCache.has(normalized)) {
    return wordCache.get(normalized);
  }

  try {
    const resp = await fetch(`${DICTIONARY_API_BASE}/${encodeURIComponent(normalized)}`, {
      method: 'GET',
      headers: { Accept: 'application/json' },
    });

    const result =
      resp.status === 404
        ? {
            valid: false,
            message: `"${normalized}" is not a valid English dictionary word`,
          }
        : resp.ok
          ? { valid: true, message: '' }
          : {
              valid: false,
              message: 'Could not verify that word. Please try again.',
              retryable: true,
            };

    if (!result.retryable) {
      wordCache.set(normalized, result);
    }
    return result;
  } catch {
    return {
      valid: false,
      message: 'Could not reach the dictionary. Check your connection and try again.',
      retryable: true,
    };
  }
}

export function primeDictionaryWordCache(words = []) {
  const list = Array.isArray(words) ? words : [words];
  list.forEach((raw) => {
    const normalized = String(raw ?? '')
      .trim()
      .toLowerCase()
      .replace(/[^a-z]/g, '');
    if (normalized && !wordCache.has(normalized)) {
      wordCache.set(normalized, { valid: true, message: '' });
    }
  });
}
